// extracted by mini-css-extract-plugin
export default {"root":"GA2RFValuesTableHead_root__gonK0"};